export default __webpack_public_path__ + "static/media/countryDetails.0ad02043.jpeg";